import { hourStart } from 'helpers/partner.helpers';
import { IPartnerWorkingHour, WeekDays } from 'types/Partner';
import { maskHour, maskHourInterval } from 'util/masks';

import { TableCell, TableRow } from '@mui/material';

type IPartnerRowHour = {
  day: string;
  value: IPartnerWorkingHour;
};

export const PartnerRowHourWorking: React.FC<IPartnerRowHour> = ({
  day,
  value,
}) => {
  return (
    <TableRow key={day}>
      <TableCell sx={{ paddingY: 1 }}>
        {WeekDays[day as keyof typeof WeekDays]}
      </TableCell>
      <TableCell sx={{ paddingY: 1 }}>{hourStart(value)}</TableCell>
      <TableCell sx={{ paddingY: 1 }}>{maskHour(value?.end)}</TableCell>
      <TableCell sx={{ paddingY: 1 }}>
        {maskHourInterval(value?.interval)}
      </TableCell>
    </TableRow>
  );
};

